module.exports = __webpack_public_path__ + "img/logo_text_en_2027.5ea9ee18.png";